var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcKolsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1221 9.82887L14.9321 9.20887L12.1221 2.58887L9.31207 9.21887L2.12207 9.82887L7.58207 14.5589L5.94207 21.5889L12.1221 17.8589L18.3021 21.5889L16.6721 14.5589L22.1221 9.82887ZM12.1221 15.9889L8.36207 18.2589L9.36207 13.9789L6.04207 11.0989L10.4221 10.7189L12.1221 6.68887L13.8321 10.7289L18.2121 11.1089L14.8921 13.9889L15.8921 18.2689L12.1221 15.9889Z",
    fill: "#79767D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKolsInactive);
export default __webpack_public_path__ + "static/media/ic_kols-inactive.a3bf0e90afc588604d8488cc342f0c45.svg";
export { ForwardRef as ReactComponent };